import axios from "utils/axios";
import { WellnessHeaders } from "utils/wellness";

class WellnessService {
  getWellnessVideos({ type, page, teamId }) {
    return axios.get(
      `wellness/wellness-video?page=${page}&size=10&keyword&team_id=${teamId}&status=1&type=${type}`,
      { headers: WellnessHeaders }
    );
  }

  createWellnessVideo(data) {
    return axios.post(`wellness/wellness-video`, data, {
      headers: WellnessHeaders,
    });
  }

  shareVideoThroughTeams(videoId, data) {
    return axios.post(`wellness/wellness-video/${videoId}/team/share`, data, {
      headers: WellnessHeaders,
    });
  }

  getTrainingDocuments({ page, teamId }) {
    return axios.get(
      `user/teams/${teamId}/training-documents?page=${page}&size=10&team_id=${teamId}&status=1`,
      { headers: WellnessHeaders }
    );
  }

  getTrainingDocumentById(teamId, id) {
    return axios.get(`user/teams/${teamId}/training-documents/${id}`, {
      headers: WellnessHeaders,
    });
  }

  createTrainingDocument(teamId, data) {
    return axios.post(`user/teams/${teamId}/training-documents`, data, {
      headers: WellnessHeaders,
    });
  }

  updateTrainingDocument(teamId, id, data) {
    return axios.put(`user/teams/${teamId}/training-documents/${id}`, data, {
      headers: WellnessHeaders,
    });
  }

  shareTrainingDocument(teamId, id, data) {
    return axios.post(`user/teams/${teamId}/training-documents/${id}/share`, data, {
      headers: WellnessHeaders,
    });
  }

  deleteTrainingDocument(teamId, id) {
    return axios.delete(`user/teams/${teamId}/training-documents/${id}`, {
      headers: WellnessHeaders,
    });
  }

  deleteVideo(videoId, teamId) {
    return axios.delete(`wellness/wellness-video/${videoId}/${teamId}`, {
      headers: WellnessHeaders,
    });
  }

  async getTriviaCategories() {
    const response = await axios.get(`wellness/trivia/get-categories`, {
      headers: WellnessHeaders,
    });
    return response.data;
  }
  async getAllTriviaList(teamId) {
    const response = await axios.get(`/wellness/trivia/list-trivia/${teamId}`, {
      headers: WellnessHeaders,
    });
    return response.data;
  }
  async getAllTriviaQuestions(teamId) {
    const response = await axios.get(
      `/wellness/trivia/get-team-trivia-questions/${teamId}`,
      {
        headers: WellnessHeaders,
      }
    );
    return response.data;
  }
  async addTriviaQuestions(payload) {
    const response = await axios.post(
      `/wellness/trivia/add-trivia-question`,
      payload,
      {
        headers: WellnessHeaders,
      }
    );
    return response.data;
  }
  async createTrivia(payload) {
    const response = await axios.post(
      `/wellness/trivia/create-trivia`,
      payload,
      {
        headers: WellnessHeaders,
      }
    );
    return response.data;
  }
  async getIndividualTriviaQuestions(teamId, triviaId) {
    const response = await axios.get(
      `/wellness/trivia/trivia-question/${teamId}/${triviaId}`,
      {
        headers: WellnessHeaders,
      }
    );
    return response.data;
  }
  async deleteIndividualTriviaQuestions(teamId, triviaId) {
    const response = await axios.delete(
      `/wellness/trivia/delete-trivia/${teamId}/${triviaId}`,
      {
        headers: WellnessHeaders,
      }
    );
    return response.data;
  }
  async getActiveTrivia(teamId, userId) {
    const response = await axios.get(
      `/wellness/trivia/get-active-trivia-questions/${teamId}/${userId}`,
      {
        headers: WellnessHeaders,
      }
    );
    return response.data;
  }
  async closeActiveTrivia(triviaId, teamId) {
    const response = await axios.get(
      `/wellness/trivia/end-trivia/${triviaId}/${teamId}`,
      {
        headers: WellnessHeaders,
      }
    );
    return response.data;
  }
  async answerTrivia(payload) {
    const response = await axios.post(
      `/wellness/trivia/user-trivia-answers`,
      payload,
      {
        headers: WellnessHeaders,
      }
    );
    return response.data;
  }
  async viewTriviaResponses(triviaId, teamId) {
    const response = await axios.get(
      `/wellness/trivia/team-trivia-response/${teamId}/${triviaId}`,
      {
        headers: WellnessHeaders,
      }
    );
    return response.data;
  }
}

export default new WellnessService();
